import React from 'react';
import { Button, Modal } from 'react-bootstrap-5';

type RethinkBatchCompleteModalProps = {
  saveContact: boolean,
  onHide: () => void
}

export default function RethinkBatchCompleteModal(
  { saveContact, onHide }: RethinkBatchCompleteModalProps
) {

  return (
    <>
      <Modal.Header closeButton>
        <h5 className="mb-0">List Creation Complete</h5>
      </Modal.Header>
      <Modal.Body>
        <div>
          Property {saveContact ? 'and owner contact data have' : 'data has'} been added to your list.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
